import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { useState, useEffect } from 'react';
import { FilterMatchMode } from 'primereact/api';
import { getAllArticles, deleteArticle } from '../../service/article';
import './NewsGrid.scss';

function NewsGrid() {
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        getAllArticles()
            .then(response => {
                setTableData(response.data.tableData);
            })
            .catch(error => {
                console.error("Error fetching articles:", error);
            });
    }, []);

    function handleDeleteArticle(id) {
        deleteArticle(id)
            .then(response => {
                if (response.status === 200) {
                    window.location.reload();
                }
            })
            .catch(error => {
                console.error("Error deleting article:", error);
            });
    }

    function lastModifiedTemplate(rowData) {
        return formatDate(rowData.lastModified);
    }
    function createdAtTemplate(rowData) {
        return formatDate(rowData.createdAt);
    }
    function idTemplate(rowData){
        return <span style={{ fontWeight: 'bold' }}>{"IEXN-" +  rowData.id}</span>;
    }
    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.status} severity={getSeverity(rowData)}></Tag>;
    };

    const getSeverity = (rowData) => {
        switch (rowData.status) {
            case 'PUBLISHED':
                return 'success';

            case 'DRAFT':
                return 'warning';

            case 'DELETED':
                return 'danger';

            default:
                return null;
        }
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }

    function actionTemplate(rowData) {
        return (
            <div>
                <Button className='gen-button' variant="solid" color="primary"
                    onClick={() => window.location.href = `/admin/article?id=${rowData.id}`}>
                    View
                </Button>
                <Button className='gen-button' variant="plain" color="neutral"
                    onClick={() => window.location.href = `/admin/editor?id=${rowData.id}`}>
                    Edit
                </Button>
                {
                   (rowData.status != 'DELETED') && (<Button className='gen-button' variant="soft" color="danger"
                        onClick={() => handleDeleteArticle(rowData.id)}>
                        Delete
                    </Button>)
                }
            </div>
        );
    }
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        lastModified: { value: null, matchMode: FilterMatchMode.DATE_IS },
    });

    return (
        <div className="table-container">
            <div>
                <Button style={{ marginTop: 10 }} variant="solid" color="primary" onClick={() => window.location.href = '/admin/editor?id=0'}>
                    Write New Article
                </Button>
            </div>

            <div className="datatable-wrapper">
                <DataTable value={tableData} filters={filters} filterDisplay='row' globalFilterFields={['title', 'lastModified']} 
                paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]} >
                    <Column field="id" header="Id" body={idTemplate} sortable style={{ width: '8%' }}></Column>
                    <Column field="title" filter filterPlaceholder="Search by name" header="Title" sortable style={{ width: '30%' }}></Column>
                    <Column field="createdAt" body={createdAtTemplate} header="Created At" sortable style={{ width: '15%' }}></Column>
                    <Column field="lastModified" body={lastModifiedTemplate} header="Last Modified" style={{ width: '15%' }} sortable></Column>
                    <Column field="status" header="Status" body={statusBodyTemplate} sortable style={{ width: '10%' }}></Column>
                    <Column field="action" body={actionTemplate} header="Action" sortable style={{ width: '17%' }}></Column>
                </DataTable>    
            </div>
        </div>
    );
}

export default NewsGrid;